/* MTi GROUP — Case Study Template
   - Reading progress bar
   - Sidebar TOC scrollspy
   - Share-rail copy-link button
   - Newsletter inline submit (intercept and show success state)
   - Video play (swap placeholder for iframe) */
(function () {
  function init() {
    initProgress();
    initScrollspy();
    initCopyLink();
    initNewsletter();
    initVideoPlay();
  }

  function initProgress() {
    var bar = document.querySelector('.cstpl-progress__bar');
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var sh = h.scrollHeight - h.clientHeight;
      var pct = sh > 0 ? (h.scrollTop / sh) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  function initScrollspy() {
    var links = document.querySelectorAll('.cstpl-toc__link');
    if (!links.length) return;
    var ids = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') ids.push(href.substring(1));
    });
    function update() {
      var current = ids[0];
      for (var i = 0; i < ids.length; i++) {
        var el = document.getElementById(ids[i]);
        if (!el) continue;
        var top = el.getBoundingClientRect().top;
        if (top < 200) current = ids[i];
      }
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        a.classList.toggle('is-active', href === '#' + current);
      });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initCopyLink() {
    document.querySelectorAll('[data-cstpl-copy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { flash(btn); });
        } else {
          var ta = document.createElement('textarea');
          ta.value = url; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); flash(btn); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });
  }

  function flash(btn) {
    var prev = btn.getAttribute('aria-label') || '';
    btn.setAttribute('aria-label', 'Copied!');
    btn.classList.add('is-copied');
    setTimeout(function () {
      btn.setAttribute('aria-label', prev);
      btn.classList.remove('is-copied');
    }, 1400);
  }

  function initNewsletter() {
    document.querySelectorAll('.cstpl-newsletter__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        var email = input ? input.value.trim() : '';
        if (!email || email.indexOf('@') === -1) return;
        if (form.dataset.cstplLocal === 'true') {
          e.preventDefault();
          var success = document.createElement('div');
          success.className = 'cstpl-newsletter__success';
          success.textContent = "You're in. We'll send the next report to " + email + '.';
          form.parentNode.replaceChild(success, form);
        }
      });
    });
  }

  function initVideoPlay() {
    // Embedded video (YouTube/Vimeo URL): swap the poster for an iframe.
    document.querySelectorAll('.cstpl-video__play[data-cstpl-video]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-cstpl-video');
        if (!src) return;
        var frame = btn.closest('.cstpl-video__frame');
        if (!frame) return;
        var iframe = document.createElement('iframe');
        iframe.className = 'cstpl-video__player';
        iframe.src = src;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');
        frame.innerHTML = '';
        frame.appendChild(iframe);
      });
    });

    // Uploaded (Shopify-hosted) video: reveal native controls on the existing
    // <video> and play. Keeps the branded poster + play button as the cover.
    document.querySelectorAll('.cstpl-video__play[data-cstpl-video-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var frame = btn.closest('.cstpl-video__frame');
        var video = frame && frame.querySelector('video.cstpl-video__media');
        if (!video) return;
        video.setAttribute('controls', '');
        btn.remove();
        var dur = frame.querySelector('.cstpl-video__duration');
        if (dur) dur.remove();
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') { playing.catch(function () {}); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
